<template>
  <el-row ref="top" v-if="hideOnEmpty === true ? all.length > 0 : true">
    <el-col :span="24" class="mb-5" v-if="showToolbar">
      <slot name="toolbar">
        <toolbar
          :to="to"
          :icon="icon"
          :title="title"
          :create="createAction && !showEditForm"
          :back="backAction"
        ></toolbar>
      </slot>
    </el-col>
    <template v-if="showEditForm">
      <el-col :span="24">
        <toolbar
          icon="icon-note"
          :title="
            (action === 'create'
              ? $t('datatable.create')
              : $t('datatable.edit')) +
            ' ' +
            subtitle
          "
          save
          cancel
          :show-save-button="showSaveButton"
          @save="save"
          @cancel="cancel"
        />
      </el-col>
      <el-col :span="24">
        <el-form
          ref="form"
          :model="one"
          :rules="rules"
          label-position="top"
          status-icon
          @submit.native.prevent
        >
          <slot></slot>
        </el-form>
      </el-col>
    </template>
    <el-col :span="24">
      <vue-good-table
        :title="title"
        :columns="columnsFormat"
        :rows="all"
        :search-options="searchOptions"
        :pagination-options="paginationOptions"
        :sort-options="sortOptions"
        styleClass="vgt-table striped"
      >
        <template slot="emptystate">
          {{ $t("withoutRecords") }}
        </template>
        <div slot="table-actions">
          <slot name="table-actions-pre"></slot>
          <el-button
            type="default"
            size="mini"
            icon="fas fa-sync-alt"
            v-tooltip="$t('vtool.update')"
            @click="getAll(true)"
            v-if="refreshAction"
          ></el-button>
          <el-dropdown
            v-if="showExportButton"
            @command="exportTo"
            trigger="click"
            class="float-right text-primary"
          >
            <el-button
              type="default"
              class="ml-1"
              size="mini"
              v-tooltip="$t('export')"
            >
              <i class="fas fa-file-export"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="excelss"
                ><i class="far fa-file-excel"></i> Excel</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <slot name="table-actions-post"></slot>
          <el-button
            type="info"
            size="mini"
            class="relative"
            icon="fas fa-inbox"
            v-tooltip="$t('fillTray')"
            v-if="traerCasos"
            @click="llenarBandeja()"
            ><i class="fas fa-plus icon-mas"></i
          ></el-button>
          <el-button
            type="success"
            size="mini"
            icon="fas fa-globe"
            v-tooltip="$t('showAll')"
            v-if="filterAll"
            @click="filterAlls()"
          ></el-button>
          <el-button
            type="info"
            size="mini"
            icon="fas fa-id-card"
            v-tooltip="$t('filterbyContact')"
            v-if="filterContact"
            @click="filterContactos()"
          ></el-button>
          <el-button
            type="warning"
            size="mini"
            icon="fas fa-user"
            v-tooltip="$t('filterbyUser')"
            v-if="filterUser"
            @click="filterUsuarios()"
          ></el-button>
        </div>

        <template slot="table-column" slot-scope="props">
          <slot :name="'table-column-' + props.column.field" :props="props">{{
            props.column.label
          }}</slot>
        </template>
        <template slot="table-row" slot-scope="props">
          <template v-if="store === 'correos'">
            <template v-if="props.column.field === 'defaultuser'">
              <el-tag
                v-if="
                  props.row.defaultuser === 'SI' ||
                  props.row.defaultuser === 'Si'
                "
                class="bg-green"
                >{{ $t("casillasCorreo.default") }}</el-tag
              >
            </template>
            <template v-if="props.column.field === 'defaultcontact'">
              <el-tag
                v-if="
                  props.row.defaultcontact === 'SI' ||
                  props.row.defaultcontact === 'Si'
                "
                class="bg-green"
                >{{ $t("casillasCorreo.default") }}</el-tag
              >
            </template>
          </template>
          <template v-if="props.column.field === 'actions'">
            <div class="whitespace-no-wrap">
              <slot name="table-row-actions" :props="props"></slot>

              <el-button
                :type="toEdit === props.row.id ? 'warning' : 'info'"
                size="mini"
                :icon="
                  !editPermissions.modificar && editPermissions.ver
                    ? 'fas fa-search'
                    : 'fas fa-pen'
                "
                v-tooltip="$t('vtool.modify')"
                @click="handleEdit(props.row)"
                v-if="
                  editAction &&
                  (editPermissions.modificar || editPermissions.ver)
                "
              ></el-button>
              <el-button
                class="infoTooltip"
                size="mini"
                icon="fas fa-info"
                v-tooltip="
                  store === 'actividadesprogramadas/estados' &&
                  props.row.id > 0 &&
                  props.row.id < 5
                    ? $t('actividadprogramada.notDeleteDefaultState')
                    : $t('casillasCorreo.defaultMailBox')
                "
                v-if="
                  props.row.nombrecuenta === 'support@beaware360.com' ||
                  (store === 'actividadesprogramadas/estados' &&
                    props.row.id > 0 &&
                    props.row.id < 5)
                "
              ></el-button>
              <el-button
                class="infoTooltip"
                size="mini"
                icon="fas fa-info"
                v-tooltip="
                  store === 'templatecorreo'
                    ? $t('template.notDeleteDefaultTemplate')
                    : ''
                "
                v-if="store === 'templatecorreo' && props.row.nativo === 1"
              ></el-button>
              <el-button
                :type="toDestroy === props.row.id ? 'warning' : 'danger'"
                size="mini"
                :icon="
                  toDestroy === props.row.id
                    ? 'fas fa-exclamation-circle'
                    : 'far fa-trash-alt'
                "
                v-tooltip="$t('vtool.remove')"
                @click="destroy(props.row.id)"
                v-if="
                  store === 'templatecorreo' &&
                  props.row.nativo === 0 &&
                  destroyPermissions
                "
              ></el-button>

              <el-button
                :type="toDestroy === props.row.id ? 'warning' : 'danger'"
                size="mini"
                :icon="
                  toDestroy === props.row.id
                    ? 'fas fa-exclamation-circle'
                    : 'far fa-trash-alt'
                "
                v-tooltip="$t('vtool.remove')"
                @click="destroy(props.row.id)"
                v-if="
                  store !== 'templatecorreo' &&
                  deleteAction &&
                  destroyPermissions &&
                  !(
                    store === 'actividadesprogramadas/estados' &&
                    props.row.id > 0 &&
                    props.row.id < 5
                  ) &&
                  props.row.nombrecuenta !== 'support@beaware360.com'
                "
              ></el-button>
              <el-button
                type="success"
                size="mini"
                icon="fas fa-plus"
                v-tooltip="$t('assignCase')"
                v-if="asignarCaso"
                @click="tomarCaso(props.row)"
              ></el-button>
            </div>
          </template>
          <slot
            :name="'table-row-' + props.column.field"
            :props="props"
            v-else
            >{{ props.formattedRow[props.column.field] }}</slot
          >
        </template>
      </vue-good-table>
    </el-col>
  </el-row>
</template>

<style lang="scss">
@import "~vue-good-table/dist/vue-good-table.css";

.icon-mas {
  font-size: 7px;
  position: absolute;
  top: 3px;
  right: 4px;
}

.vgt-global-search {
  border: 0 !important;
  background: none !important;

  form {
    display: inherit !important;
  }

  .vgt-global-search__input {
    @apply p-0;

    .input__icon {
      position: absolute;
      top: 3px !important;
      right: 15px;
      max-width: 32px;
      left: inherit;

      .magnifying-glass {
        width: 13px;
        height: 13px;

        &:before {
          width: 8px;
          height: 3px;
          bottom: -4px;
        }
      }
    }

    .vgt-pull-left {
      float: right !important;
    }

    .vgt-input {
      width: 100%;
      background-color: #fff;
      border: 0;
      border: 1px solid config("colors.grey-light") !important;
      border-radius: 3px;
      -webkit-box-shadow: none;
      box-shadow: none;
      color: #565656;
      height: 30px;
      max-width: 100%;
      padding: 7px 40px 7px 10px;
      -webkit-transition: all 300ms linear 0s;
      transition: all 300ms linear 0s;

      &:focus {
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: #b7b7b7;
      }

      @screen sm {
        width: 70%;
      }
      @screen lg {
        width: 40%;
      }
    }
  }
}

.vgt-table {
  border: 0 !important;
  font-size: 14px !important;

  &.striped tbody tr:nth-of-type(odd) {
    @apply bg-grey-lightest;
  }

  thead th {
    @apply border-b bg-grey-light;
    background: none !important;
  }

  tbody td {
    vertical-align: middle !important;
    border-bottom: 0 !important;
  }
}

.vgt-wrap__actions-footer {
  @apply border-0 border-b bg-grey-light;
}

.vgt-wrap__footer {
  border: 0 !important;
  background: none !important;
  font-size: 0.9rem !important;

  .footer__row-count__label,
  .footer__row-count__select,
  .footer__navigation,
  .footer__navigation__page-btn span {
    font-size: 0.9rem !important;
  }
}

.vgt-left-align {
  text-align: left !important;
}
.bg-green {
  color: rgb(46, 204, 113);
  background-color: rgba(46, 204, 112, 0.137);
  text-align: center;
  min-width: 65px;
}
.bg-red {
  color: #c32905;
  background-color: rgba(204, 46, 46, 0.137);
  text-align: center;
  min-width: 65px;
}
.infoTooltip {
  cursor: help;
  width: 28px !important;
}
.striped {
  max-width: 100vw !important;
}
</style>

<script>
import { VueGoodTable } from "vue-good-table";
import { toExcelThree, toPdf } from "@/util/exporter";

export default {
  components: {
    VueGoodTable,
  },
  props: {
    autoInit: {
      type: Boolean,
      default: true,
    },
    to: {
      type: Object,
      required: false,
      default: null,
    },
    showToolbar: {
      type: Boolean,
      default: true,
      required: false,
    },
    showEditForm: {
      type: Boolean,
      default: false,
      required: false,
    },
    appendData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: "icon-doc",
      required: false,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
    subtitle: {
      type: String,
      default: "",
      required: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    store: {
      type: String,
      required: false,
    },
    query: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    data: {
      type: Array,
      required: false,
    },
    rules: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    createAction: {
      type: Boolean,
      default: true,
    },
    editAction: {
      type: Boolean,
      default: true,
    },
    asignarCaso: {
      type: Boolean,
      default: false,
    },
    deleteAction: {
      type: Boolean,
      default: true,
    },
    refreshAction: {
      type: Boolean,
      default: true,
    },
    traerCasos: {
      type: Boolean,
      default: false,
    },
    backAction: {
      type: Boolean,
      default: false,
    },
    sortOptions: {},
    searchable: {
      type: Boolean,
      default: true,
    },
    paginable: {
      type: Boolean,
      default: true,
    },
    showExportButton: {
      type: Boolean,
      default: false,
    },
    hideOnEmpty: {
      type: Boolean,
      default: false,
    },
    stateAllName: {
      type: String,
      default: "all",
    },
    stateOneName: {
      type: String,
      default: "one",
    },
    filterAll: {
      type: Boolean,
      default: false,
    },
    filterContact: {
      type: Boolean,
      default: false,
    },
    filterUser: {
      type: Boolean,
      default: false,
    },
    updateOnSave: {
      type: Boolean,
      default: false,
    },
    isEmptyList: {
      type: Boolean,
      required: false,
      default: false,
    },
    supervisor: {
      type: String,
      required: false,
      default: "NO",
    },
  },
  data() {
    return {
      toEdit: null,
      toDestroy: null,
      searchOptions: {
        enabled: this.searchable,
        placeholder: this.$t("searchFor"),
      },
      paginationOptions: {
        enabled: this.paginable,
        mode: "records",
        perPage: 10,
        position: "bottom",
        perPageDropdown: [10, 25, 50, 100],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        nextLabel: this.$t("next"),
        prevLabel: this.$t("previous"),
        rowsPerPageLabel: this.$t("recordsPerPage"),
        ofLabel: this.$t("of"),
        pageLabel: this.$t("page"),
        allLabel: this.$t("all"),
      },
      editingId: null,
    };
  },
  computed: {
    all() {
      return (
        this.data || this.$store.getters[`${this.store}/${this.stateAllName}`]
      );
    },
    one() {
      return this.$store.getters[`${this.store}/${this.stateOneName}`];
    },
    action() {
      return this.toEdit > 0 ? "edit" : "create";
    },
    editPermissions() {
      const route = this.to
        ? this.to.name.replace(".nuevo", ".editar")
        : this.$route.name;
      return {
        modificar: this.$getPermission("modificar", route),
        ver: this.$getPermission("ver", route),
        add: this.$getPermission("crear", route),
      };
    },
    showSaveButton() {
      const route = this.to
        ? this.to.name.replace(".nuevo", ".editar")
        : this.$route.name;

      const canCreate = this.$getPermission("crear", route);
      const canEdit = this.$getPermission("modificar", route);

      return !!(this.save && (canCreate || (canEdit && this.toEdit > 0)));
    },
    destroyPermissions() {
      const route = this.to
        ? this.to.name.replace(".nuevo", "")
        : this.$route.name;
      return this.$getPermission("eliminar", route);
    },
    columnsFormat() {
      const numberFields = new Set([
        "cantidadstages",
        "port",
        "id",
        "tipo",
        "validacion",
        "longitude",
        "tipoestado",
        "default",
        "limite",
        "notificacion",
        "pordefecto",
        "duracion",
        "editable",
        "busqueda",
      ]);

      return this.columns.map((column) => {
        if (numberFields.has(column.field)) {
          return { ...column, type: "number" };
        }
        return column;
      });
    },
  },
  methods: {
    getAll(force) {
      const params = Object.assign({}, { force: !!force }, this.query || {});
      return this.$store
        .dispatch(`${this.store}/getAll`, params)
        .then((data) => {
          if (data.length !== 0 && this.store === "pasos") {
            if (data[0].warning) {
              this.$store.commit("pasos/setMsgWarning", data[0].warning);
            } else {
              this.$store.commit("pasos/setMsgWarning", "");
            }
          } else {
            this.$store.commit("pasos/setMsgWarning", "");
          }
        })
        .catch(() => this.$notification("error"));
    },
    getBy(id) {
      return this.$store
        .dispatch(`${this.store}/getBy`, { id })
        .then(() => {
          if (this.store === "roles") {
            this.$emit("setSupervisorField");
          }
        })
        .catch(() => this.$notification("error"));
    },
    save() {
      if (this.store === "correos") {
        if (
          this.one.defaultuser === null ||
          this.one.defaultuser === undefined
        ) {
          this.one.defaultuser = "NO";
        }
        if (
          this.one.defaultcontact === null ||
          this.one.defaultcontact === undefined
        ) {
          this.one.defaultcontact = "NO";
        }
      }
      if (this.store === "roles") {
        if (this.supervisor === "NO") {
          this.one.supervisor = 0;
        } else {
          this.one.supervisor = 1;
        }
      }
      if (this.isEmptyList === true && this.store === "customfields") {
        this.$notification("error", this.$t("customFields.emptyList"));
      } else {
        this.$validateForm("form").then((valid) => {
          if (valid) {
            Object.assign(this.one, this.appendData);
            this.$store
              .dispatch(`${this.store}/save`)
              .then(() => {
                if (this.updateOnSave) {
                  this.getAll(true);
                }
                this.getAll(true);
                this.cancel();
                this.$emit("after-save", true);
                this.$notification("success");
                this.$emit("newSave");
                this.$emit("cleaner");
                this.$emit("getCFValues");
                this.$emit("editToCreatedStoreCorreos");
                this.$emit("cleanSupervisorField");
              })
              .catch((error) => {
                this.$emit("after-save", false);
                this.$notification("error", error.response.data.message);
              });
          }
        });
      }
    },
    handleEdit(row) {
      this.edit(row);
      this.$emit("start-edit", row.id);
    },
    edit(item) {
      if (this.showEditForm) {
        this.$emit("eventDisabled", true);
        if (this.toEdit !== item.id) {
          this.toEdit = item.id;
          this.getBy(item.id);
        } else {
          this.cancel();
        }
      } else {
        const route = this.to
          ? {
              name: this.to.name.replace(".nuevo", ".editar"),
              params: { id: item.id },
            }
          : `${this.$route.path}/editar/${item.id}`;
        this.$router.push(route);
      }
    },
    destroy(id) {
      if (this.store === "casillascorreos") {
        this.$confirm(this.$t("destroyMessageRegister"), this.$t("danger"), {
          confirmButtonText: "OK",
          cancelButtonText: this.$t("cancel"),
          type: "warning",
        })
          .then(() => {
            return this.$store
              .dispatch(this.store + "/destroy", { id })
              .then(() => {
                this.$notification("success");
              })
              .catch((error) =>
                error.response.data.message != null
                  ? this.$notification("error", error.response.data.message)
                  : this.$notification("error")
              )
              .finally(() => {
                this.toDestroy = null;
                this.getAll(true);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("canceledAction"),
            });
          });
      } else {
        if (this.toDestroy === id) {
          return this.$store
            .dispatch(this.store + "/destroy", { id })
            .then(() => {
              this.$notification("success");
            })
            .catch((error) =>
              error.response.data.message != null
                ? this.$notification("error", error.response.data.message)
                : this.$notification("error")
            )
            .finally(() => {
              this.toDestroy = null;
              this.getAll(true);
            });
        } else {
          this.toDestroy = id;
          setTimeout(() => {
            if (this.toDestroy === id) {
              this.toDestroy = null;
            }
          }, 3000);
        }
      }
    },
    cancel() {
      this.getBy(0).then(() => {
        this.$emit("eventDisabled", false);
        this.toEdit = null;
        this.$resetForm("form");
        this.$emit("vaciarLista");
      });
      this.$emit("newSave");
    },
    exportTo(command) {
      if (command === "pdf") {
        toPdf(this.all, this.title, this.columns, "datatable");
      }
      if (command === "excelss") {
        toExcelThree(this.all, this.title, this.columns, "datatable");
      }
    },
    llenarBandeja() {
      this.$store
        .dispatch("casos/custom", {
          method: "get",
          endpoint: "caso/llenarbandeja",
          dataToSend: null,
        })
        .then((data) => {
          const params = Object.assign({}, { force: true }, {});
          this.$store.dispatch("casos/getAll", params);
          this.$store.dispatch("casos/grupo/getAll", params);
        });
    },
    tomarCaso(caso) {
      this.$store
        .dispatch("casos/custom", {
          method: "put",
          endpoint: "caso/tomarcaso",
          dataToSend: { id: caso.id },
        })
        .then((data) => {
          const params = Object.assign({}, { force: true }, {});
          this.$store.dispatch("casos/getAll", params);
          for (let x = 0; x <= this.all.length; x++) {
            if (this.all[x].id === data.id) {
              this.all.splice(x, 1);
            }
          }
        });
    },
    filterAlls() {
      const params = Object.assign(
        {},
        { force: true, query: { cantidad: 10, pagina: 1 } }
      );
      this.$store.dispatch("gruposkill/getAll", params);
    },
    filterContactos() {
      const params = Object.assign(
        {},
        { force: true, query: { tipo: 2, cantidad: 10, pagina: 1 } }
      );
      this.$store.dispatch("gruposkill/getAll", params);
    },
    filterUsuarios() {
      const params = Object.assign(
        {},
        { force: true, query: { tipo: 1, cantidad: 10, pagina: 1 } }
      );
      this.$store.dispatch("gruposkill/getAll", params);
    },
  },
  mounted() {
    if (this.autoInit) {
      this.getAll(true).then(() => {
        this.cancel();
      });
    }
  },
};
</script>
